





import Vue from 'vue'
import Student from '@/models/Students/Student'

export default Vue.extend({
  name: 'PatientIndexColumn',
  props: {
    row: Object as () => Student,
  }
})
